import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import get from 'lodash.get';
import isNil from 'lodash.isnil';
import './StudentSummaryNavigation.scss';
import { getUrlString } from '../../../../utils/shared/urlUtils';
import NavigationBar from '../../../navigation/NavigationBar';
import { TITLE } from '../../../../constants/shared/CommonConstants';

const { BACK_TO_CLASS_LIST } = TITLE;

const StudentSummaryNavigation = ({
    selectedTabId,
    chosenDistrictUid,
    studentSummaryNavTabs,
    lastLocation,
    LinkWrapper,
    onNavigationTabClick,
}) => {
    const [lastPathName, setLastPathName] = useState(null);
    const [lastSearchParams, setLastSearchParams] = useState(null);

    useEffect(() => {
        if (isNil(lastPathName)) {
            setLastPathName(get(lastLocation, 'pathname', ''));
            setLastSearchParams(get(lastLocation, 'search', ''));
        }
    }, [lastPathName, lastLocation]);

    const isBackButtonEnabled =
        !studentSummaryNavTabs.find(tab => tab.path.includes(lastPathName)) && lastPathName;

    return (
        <div className="ss-navigation">
            <div className="back-link">
                {isBackButtonEnabled ? (
                    <LinkWrapper
                        path={getUrlString(lastPathName, lastSearchParams)}
                        content={BACK_TO_CLASS_LIST}
                    />
                ) : (
                    BACK_TO_CLASS_LIST
                )}
            </div>
            <NavigationBar
                divTagClassName="sidenav"
                ulTagClassName="ss-nav-items"
                tabs={studentSummaryNavTabs}
                selectedTabId={selectedTabId}
                chosenDistrictUid={chosenDistrictUid}
                LinkWrapper={LinkWrapper}
                onNavigationTabClick={onNavigationTabClick}
            />
        </div>
    );
};

StudentSummaryNavigation.defaultProps = {
    lastLocation: {},
    chosenDistrictUid: '',
    studentSummaryNavTabs: [],
    selectedTabId: '',
    LinkWrapper: () => {},
    onNavigationTabClick: () => {},
};

StudentSummaryNavigation.propTypes = {
    lastLocation: PropTypes.object,
    studentSummaryNavTabs: PropTypes.array,
    chosenDistrictUid: PropTypes.string,
    selectedTabId: PropTypes.string,
    LinkWrapper: PropTypes.func,
    onNavigationTabClick: PropTypes.func,
};

export default StudentSummaryNavigation;
